exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * @Author: Zewei\n * @Date:   2018-02-01T10:32:02+08:00\n * @Last modified by:\n * @Last modified time: 2018-02-24T16:56:59+08:00\n */\n.certificate-head-class {\n  min-width: 120px;\n}\n.hoverLayout {\n  cursor: pointer;\n}\n.hoverLayout:hover {\n  color: #f5222d;\n}\n.ant-calendar-month-panel-header {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/routes/EmployeeManagement/style.less
// module id = 1645
// module chunks = 0